module.exports = __webpack_public_path__ + "img/kutoup-login-logo.d881773e.png";